export default "/images/45a39d047893a02e7189f64aa0c68d44.png";